﻿"use strict";

import * as dawaAutocomplete2 from 'dawa-autocomplete2';
const utmgeoconv = require("utmgeoconv");

class ConnectionCalculator {
    constructor(calculator) {
        this.calculator = calculator;
        if (!this.calculator) return;

        this.step1 = calculator.querySelector("#connectioncalculator__step1");
        this.step2 = calculator.querySelector("#connectioncalculator__step2");
        this.step3 = calculator.querySelector("#connectioncalculator__step3");

        if (!this.step1 || !this.step2 || !this.step3) {
            this.calculator.remove();
            console.error("ConnectionCalculator: Steps not found");
            return;
        }

        if (!window.jQuery) {
            this.calculator.remove();
            console.error("ConnectionCalculator: jQuery not found");
            return;
        }

        this.doAllTheJQueryStuff();

        this.addressInput = calculator.querySelector("#addressSearch");

        if (this.addressInput) {

            dawaAutocomplete2.dawaAutocomplete(this.addressInput, {
                select: selected => {
                    this.getCoordinatesBySelected(selected);
                }
            });
        }
    }

    doAllTheJQueryStuff() {


        this.$ = window.jQuery;

        var that = this;

        this.$("#connectioncalculator__step2, #connectioncalculator__step2-1, #connectioncalculator__step2-9, #connectioncalculator__step3").hide();

        this.$("#connectioncalculator__step1 form").validate({
            rules: {
                arealKaelderplan: {
                    required: true,
                    depends: function (element) {
                        that.$("#kaelder1Sal-kaelder").is(":checked");
                    }
                },
                areal1salsplan: {
                    required: true,
                    depends: function (element) {
                        that.$("#kaelder1Sal-1sal").is(":checked");
                    }
                }
            }
        });

        this.$("#kaelder1Sal-kaelder").click(function () {
            if (that.$(this).is(":checked")) {
                that.$("#inp__arealKaelderplan").show();
            }
            else {
                that.$("#inp__arealKaelderplan").hide();
            }
        });

        this.$("#connectioncalculator__step1 form").on("submit", function (e) {

            e.preventDefault();

            var errors = [];
            var isExtension = that.$(this).find("#eksisterendeNet-ja-udvidelse:checked").length > 0;
            if (that.$(this).find("[name=eksisterendeNet]:checked").length == 0) {
                that.$(this).find("#eksisterendeNet-vedikke").attr("checked", "checked");
            }

            if (that.$(this).valid()) {
                var antalMeter = parseInt(that.$(this).find("[name=antalMeter]").val());
                var arealGrund = parseFloat(that.$(this).find("[name=arealGrundplan]").val().replace(/\./g, "").replace(/\,/g, "."));
                var arealKaelder = that.$(this).find("#kaelder1Sal-kaelder:checked").length > 0 ? parseFloat("0" + that.$(this).find("[name=arealKaelderplan]").val().replace(/\./g, "").replace(/\,/g, ".")) * .25 : 0;

                var arealTotal = arealGrund + arealKaelder;

                var price = 0;

                // investeringsbidrag
                for (let i = 0; i < prices.length; i++) {

                    // find hvor grundareal er mere en fra og mindre end til
                    if (parseFloat("0" + prices[i].from) <= arealTotal && parseFloat("0" + prices[i].to) >= arealTotal) {

                        // effektbidrag
                        price = parseFloat(prices[i].baseprice.replace(/\./g, "").replace(/\,/g, "."));
                        console.log("effektbidrag", price);

                        // hvis fra er mere end nul, lægges der pris pr. yderligere m2 på
                        // alt udover "fra" ganges med unitprice
                        if (parseInt(prices[i].from) > 0) {
                            var extensionSqMeters = arealTotal - parseInt(prices[i].from);
                            var unitPrice = parseFloat(prices[i].unitprice.replace(/\./g, "").replace(/\,/g, "."));
                            var extensionAmount = (extensionSqMeters * unitPrice);
                            console.log("yderligere m2", extensionSqMeters, unitPrice, extensionAmount);
                            price = price + extensionAmount;
                        }
                    }

                }

                // stikledningsbidrag
                var tenPct = price * 0.1;
                console.log("10% tillæg", tenPct);
                var pipeMeters = Math.max(antalMeter, 5);
                var pipeAmount = pipeMeters * pipePrice;
                console.log("stikledning", pipeMeters, pipePrice, pipeAmount);
                console.log("afslutning i hus", housePrice);
                console.log("opstartstillæg", initialPrice);
                
                var extensionAmount = (isExtension ? arealTotal * extensionPrice : 0);
                var newAreaDiscountAmount = (isExtension ? discountNewArea : 0);
                
                    console.log("byggemodning", arealTotal, extensionPrice, extensionAmount);
                    console.log("rabat ved nye områder", newAreaDiscountAmount);
                    
                price = price + tenPct + pipeAmount + housePrice + initialPrice + extensionAmount + newAreaDiscountAmount;
                
                console.log("total pris", price);

                // afrund pris til nærmeste 100
                price = Math.round(price / 100) * 100;
                
                console.log("nærmeste 100", price);

                that.$("#connectioncalculator__price").text(that.formatNumber(price, 0, 3, '.', ',') + " kr.");
                that.$("#connectioncalculator__arealGrund").text(arealGrund);
                that.$("#connectioncalculator__antalMeter").text(antalMeter);

                that.$("#connectioncalculator__boligHar").text("");

                that.$(this).find("[name=kaelder1Sal]:checked").each(function (index) {

                    if (index > 0) {
                        $("#connectioncalculator__boligHar").html($("#connectioncalculator__boligHar").html() + " og ");
                    }
                    if (index == 0) {
                        $("#connectioncalculator__boligHar").html("Boligen har ");
                    }

                    that.$("#connectioncalculator__boligHar").html($("#connectioncalculator__boligHar").html() + that.$(this).val());

                    var input = "";

                    input = (that.$(this).val() == "kælder" ? "#inp__kaelder" : input);

                    that.$("#connectioncalculator__boligHar").html($("#connectioncalculator__boligHar").html() + " (" + that.$(input).val() + " m<sup>2</sup>)");
                });

                if (that.$("#connectioncalculator__boligHar").html() != "") {

                    that.$("#connectioncalculator__boligHar").html($("#connectioncalculator__boligHar").html() + ".");
                }

                if (that.$(this).find("[name=eksisterendeNet]:checked").val() == "Ja") {
                    that.$("#connectioncalculator__boligStik").text("gammelt fjernvarmeområde");
                }

                if (that.$(this).find("[name=eksisterendeNet]:checked").val() == "Ja, udvidelsesområde") {
                    that.$("#connectioncalculator__boligStik").text("nyetableret fjernvarmeområde");
                }

                if (that.$(this).find("[name=eksisterendeNet]:checked").val() == "Nej") {
                    that.$("#connectioncalculator__boligStik").text("ikke");
                }

                if (that.$(this).find("[name=eksisterendeNet]:checked").val() == "Ved ikke") {
                    that.$("#connectioncalculator__boligStik").text("måske");
                }


                that.$("#connectioncalculator__step1 type[submit]").html("<i class=\"fa fa-spinner fa-spin\"></i> Beregner");

                setTimeout(
                    function () {
                        // preudfyld formular i step 3
                        that.$(".umbraco-forms-field.boligoplysninger textarea").val(that.$("#connectioncalculator__result").text().replace(/^\s+|\s+$/gm, '').replace(/( {2,})/g, " ").replace("\r\n", ""));

                        // go to result
                        that.$("#connectioncalculator__step1").slideUp(200).fadeOut(200);

                        that.$("#connectioncalculator__step2").slideDown(200).fadeIn(200);


                        that.$("#connectioncalculator__step1 .connectioncalculator__button").html("Udregn pris");
                    }, 350);

                //}
            }
            return false;

        });

        that.$("[data-connectioncalculator__go]").on("click", function () {
            var goto = that.$(this).attr("data-connectioncalculator__go").split(",");
            that.goToStep(goto[0], goto[1]);
        });
    }

    goToStep(to, from) {
        this.$("#connectioncalculator__" + from).slideUp(200).fadeOut(200);
        this.$("#connectioncalculator__" + to).slideDown(200).fadeIn(200);
    }

    formatNumber(inp, n, x, s, c) {
        var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
            num = inp.toFixed(Math.max(0, ~~n));

        return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    }

    getCoordinatesBySelected(selected) {

        let url = new URL("https://dawa.aws.dk/adgangsadresser");
        url.search = new URLSearchParams({
            vejnavn: selected.data.vejnavn,
            husnr: selected.data.husnr,
            postnr: selected.data.postnr,
            struktur: "mini"
        }).toString();

        fetch(url, {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        })
        .then(response => response.json())
        .then(json => {

            if (json[0]) {
                var coords = this.calculateUtm32Coords(json[0]);
                this.searchInGis(coords, json[0]);

                this.$(".umbraco-forms-field.adresse input").val(selected.data.vejnavn + " " + selected.data.husnr);
                this.$(".umbraco-forms-field.postnrogby input").val(selected.data.postnr + " " + selected.data.postnrnavn);
            }
        })
        .catch(err => console.log(err));
    }


    calculateUtm32Coords(selectedItem) {
        return utmgeoconv.latLonToUtm(selectedItem.y, selectedItem.x, 32);
    }

    searchInGis(coords, selectedItem) {
        this.$("#connectioncalculator__step1 [type=submit]").removeClass("hidden");
        this.$("#connectioncalculator__step1-1:visible").slideUp(200).fadeOut(200);
        this.$("#connectioncalculator__step1-9:visible").slideUp(200).fadeOut(200);
        this.$("#connectioncalculator__step1-3:visible").slideUp(200).fadeOut(200);
        this.$("#connectioncalculator__step1 [type=submit]").prop("disabled", true).addClass("opacity-50");
        this.$("#connectioncalculator__step1 [type=submit]>span").text("Vent, finder område for din adresse");

        fetch(`/umbraco/api/AreaMap/GetArea?x=${coords.x}&y=${coords.y}`)
        .then(response => response.json())
        .then(data => {
            this.$("#connectioncalculator__step1 [type=submit]>span").text("Udregn pris");
            this.setAndShowResult(data);
        })
        .catch(err => console.log(err));
    }


    setAndShowResult(status) {
        this.$("#connectioncalculator__step1 [type=submit]").removeClass("hidden");
        
        /*
        •	Lag 0 = eksisterende områder = Aktiv HER SKAL DET VÆRE MULIGT AT KLIKKE PÅ KNAPPEN UDREGN PRIS
        •	Lag 1 = konverterings områder = Aktiv (er der noget med prisen der) HER SKAL DET VÆRE MULIGT AT KLIKKE PÅ KNAPPEN UDREGN PRIS
        •	Lag 2 = tilmeldings områder = Aktiv? Skal de selv kunne beregne en pris? SKAL VÆRE AKTIV OG LINKE TIL DENNE SIDE: https://www.fjernvarmefyn.dk/overvejer-du-fjernvarme/omraader
        •	Lag 3 = undersøgelses områder inaktiv? SKAL VÆRE AKTIV OG LINKE TIL DENNE SIDE: https://www.fjernvarmefyn.dk/overvejer-du-fjernvarme/overblik/undersogelsesomraader

         */

        if (status.status === 8 || status.status === 0) {
            // eksisterende
            this.$("#eksisterendeNet-ja").prop("checked", true);
        }
        else if (status.status === 9 || status.status === 1) {
            // nyt eller undersøgelse
            this.$("#eksisterendeNet-ja-udvidelse").prop("checked", true);
        }

        if (status.status === 8 || status.status === 9 || status.status === 0 || status.status === 1) {
            this.$("#connectioncalculator__step1 [type=submit]").prop("disabled", false).removeClass("opacity-50");
        }
        else {
            this.$("#connectioncalculator__step1 [type=submit]").prop("disabled", true).addClass("opacity-50");
            this.$("#eksisterendeNet-ja").prop("checked", false);
            this.$("#eksisterendeNet-ja-udvidelse").prop("checked", false);
        }

        if (status.status === -1) {
            this.$("#connectioncalculator__step1-1").slideDown(200).fadeIn(200);
        }

        if (status.status === 10 || status.status === 2) {

            this.$("#connectioncalculator__step1 [type=submit]").addClass("hidden");

            var link = status.nextStepLink;
            if (!link) {
                link = this.$("#connectioncalculator__step1-9-link").attr("href");
            }

            if (link) {
                this.$("#connectioncalculator__step1-9-link").attr("href", link).removeClass("hidden");
            }
            else {
                this.$("#connectioncalculator__step1-9-link").addClass("hidden");
            }
            this.$("#connectioncalculator__step1-9").slideDown(200).fadeIn(200);
        }

        if (status.status === 3) {

            this.$("#connectioncalculator__step1 [type=submit]").addClass("hidden");

            var link = status.nextStepLink;
            if (!link) {
                link = this.$("#connectioncalculator__step1-3-link").attr("href");
            }

            if (link) {
                this.$("#connectioncalculator__step1-3-link").attr("href", link).removeClass("hidden");
            }
            else {
                this.$("#connectioncalculator__step1-3-link").addClass("hidden");
            }
            this.$("#connectioncalculator__step1-3").slideDown(200).fadeIn(200);
        }

    }
}

const connectionCalculatorInit = function () {
    [...document.querySelectorAll(".connectioncalculator")].map(cc => new ConnectionCalculator(cc));
}
export default connectionCalculatorInit();
